module.exports = __webpack_public_path__ + "static/img/32.30da1edf.gif";